import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoDark from '../assets/images/etenant-logo-dark.png';
import { PLAY_STORE_URL } from './GooglePlayLogo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.hash]);

  const isActive = (path: string, hash = '') =>
    location.pathname === path && location.hash === hash ? 'active' : '';

  return (
    <header className={`header-nav site-header${isScrolled ? ' scrolled' : ''}`}>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logoDark} alt="eTENANT Logo" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation"
            aria-expanded={isMenuOpen}
          >
            <i className={`fa ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>

          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className={`nav-link ${isActive('/')}`} to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${isActive('/how-it-works')}`} to="/how-it-works">
                  How It Works
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${isActive('/features')}`} to="/features">
                  Features
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${isActive('/contact')}`} to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>

            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="header-download-btn"
            >
              <i className="fab fa-google-play"></i>
              Download App
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
